import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import Modal from '@/components/Modal/Modal';
import styles from './RequestProcessingModal.module.css';
import { RequestProcessingModalProps } from './RequestProcessingModal.types';

const RequestProcessingModal: FC<RequestProcessingModalProps> = ({ isOpen, onClose, type }) => {
  const { t } = useTranslation();

  if (!type) {
    return null;
  }
  const isTimeout = type === 'timeout';
  const isCreateError = type === 'createError';
  const isUpchargeError = type === 'upchargeError';

  let title, message;
  if (isTimeout) {
    title = t('requestProcessingModal.timeout.title');
    message = t('requestProcessingModal.timeout.message');
  } else if (isCreateError) {
    title = t('requestProcessingModal.createError.title');
    message = t('requestProcessingModal.createError.message');
  } else if (isUpchargeError) {
    title = t('requestProcessingModal.upchargeError.title');
    message = t('requestProcessingModal.upchargeError.message');
  } else {
    title = t('requestProcessingModal.error.title');
    message = t('requestProcessingModal.error.message');
  }

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      className={styles.requestProcessingModal}
      isOpen={isOpen}
      onClose={handleClose}
      headerContent={title}
      showTitleDivider
      bodyContent={
        <div className={styles.body}>
          <p className={styles.message}>{message}</p>
        </div>
      }
      footerContent={
        <div className={styles.footer}>
          <Button variant={ButtonVariants.Primary} onClick={handleClose} data-testid="close-button">
            {t('common.close')}
          </Button>
        </div>
      }
    />
  );
};

export default RequestProcessingModal;
